module.exports = __webpack_public_path__ + "img/al.3e3117dd.svg";